import { set } from '~/src/base/Optic';

import * as St from '../State';
import { State , Config } from '../State';

export interface Configure {
	tag : 'Configure';
	con : Config;
}

export const configure = ( con : Config ) : Configure =>
	( { tag : 'Configure' , con } );

export const exeConfigure = ( state : State , con : Configure ) : State =>
	set( St.config )( con.con )( state );
